import { Modal, Form, Row, Col, Button } from "antd";
import { useState } from "react";
import { StyledButton } from "../../../../../../components/styled-antd";
import { RenderHelper } from "../../../../human-organization/summary-employee-request/utils/render-helper";
import { HiPencilSquare } from "react-icons/hi2";
import * as _ from "lodash";

export function EditableModal({
  title,
  eRequests,
  setERequests,
  //   parentValues,
  eFields,
  mode,
  index,
}: {
  title: string;
  eRequests: any[];
  setERequests: any;
  //   parentValues: any;
  eFields: any[];
  mode: string;
  index?: number;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();

    if (mode === "edit" && _.isNumber(index)) {
      form.setFieldsValue(eRequests[index]);
    }

    setIsModalOpen(true);
  };

  const handleOk = async () => {
    const values = form.getFieldsValue();

    if (mode === "create") {
      setERequests([...eRequests, values]);
    }
    if (mode === "edit" && _.isNumber(index)) {
      let newERequests = _.cloneDeep(eRequests);
      newERequests[index] = values;

      setERequests(newERequests);
    }

    setIsModalOpen(false);
  };
  
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {mode === "create" && (
        <StyledButton bgColor="yellow" onClick={showModal} className="mb-3">
          <div className="pb-1">Thêm mới</div>
        </StyledButton>
      )}

      {mode === "edit" && (
        <Button onClick={showModal} className="mb-3">
          <div className="pb-1">
            <HiPencilSquare
              size={20}
              className="cursor-pointer"
              color="#0ea5e9"
            />
          </div>
        </Button>
      )}

      <Modal
        title={title}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <RenderHelper fields={eFields} />

            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
